import api from 'services/system/user'

export const handleSave = async (values: any, logout: () => void) => {
  let res = await api.updatePassword(values)

  if (res) logout()
}
